import { IAction } from '~/src/store';

import { ETicketPayment } from './index';

export type TBonusesResult = 'success' | 'error' | 'none'

export type TSetBonusesResult = IAction<ETicketPayment.SET_BONUSES_RESULT, TBonusesResult>

const setBonusesResult = (result: TBonusesResult): TSetBonusesResult => ({
    type: ETicketPayment.SET_BONUSES_RESULT,
    payload: result,
});

export default setBonusesResult;
